// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__UV0KH","wrapper":"Banner_wrapper__PcilU","leftCol":"Banner_leftCol__H049e","rightCol":"Banner_rightCol__3chZl","bannerBtn":"Banner_bannerBtn__E+Lrf"};